export default __webpack_public_path__ + "static/media/background.138447a4.jpg";